import { useAuth0 } from "@auth0/auth0-react";
import { Logout, Password } from "@carbon/icons-react";
import { Header, HeaderContainer, HeaderGlobalAction, HeaderGlobalBar, HeaderName, Modal, SkipToContent } from "@carbon/react";
import axios from "axios";
import { useState } from "react";
import { Link } from "react-router-dom";

const AppNav = () => {
  const { isAuthenticated, logout, user } = useAuth0();
  const [modalOpen, setModalOpen] = useState(false);

  const triggerPasswordReset = () => {
    if (isAuthenticated) {
      axios.request({
        method: 'POST',
        url: `https://${process.env.REACT_APP_AUTH0_DOMAIN}/dbconnections/change_password`,
        headers: { 'content-type': 'application/json' },
        data: {
          client_id: process.env.REACT_APP_AUTH0_CLIENT_ID,
          email: user.email,
          connection: process.env.REACT_APP_AUTH0_CONNECTION
        }
      })
        .then(({ data }) => console.log(data))
        .catch((error) => console.error(error))
        .finally(() => setModalOpen(false));
    }
  };

  return (
    <HeaderContainer
      render={() => (
        <Header aria-label="UBI App">
          <SkipToContent />

          <HeaderName element={Link} to="/" prefix="WSP">
            Utility Bill Insights
          </HeaderName>

          {isAuthenticated && (<HeaderGlobalBar>
            <HeaderGlobalAction
              aria-label={`Hi ${user.name}!`}
              tooltipAlignment="end"
            >
              <img src={user.picture} alt="User Avatar" />
            </HeaderGlobalAction>
            <HeaderGlobalAction
              aria-label="Change Password"
              onClick={() => setModalOpen(true)}
              tooltipAlignment="end"
            >
              <Password size={24} />
            </HeaderGlobalAction>
            <HeaderGlobalAction
              aria-label="Logout"
              onClick={() => {
                logout({ returnTo: window.location.origin });
              }}
              tooltipAlignment="end"
            >
              <Logout size={24} />
            </HeaderGlobalAction>
          </HeaderGlobalBar>)}

          {isAuthenticated && (<Modal
            modalHeading="Change Password"
            primaryButtonText="Request Password Change"
            secondaryButtonText="Cancel"
            size="xs"
            open={modalOpen}
            onRequestSubmit={triggerPasswordReset}
            onRequestClose={() => setModalOpen(false)}
          >
            <p>Submit a request to change your password. You will be sent a link to the <strong>Auth0 password reset page</strong> though email.</p>
            <br />
            <p>The email will be sent to: <strong>{user.email}</strong></p>
          </Modal>)}
        </Header>
      )}
    />
  )
};

export default AppNav;
